

export const AppMarketingHeader = (props) => {

    return (
        <div id="1" className="nav">
            <div className="nav-container">
                <div className="grid-3 is--nav">
                    <div className="grid_item--2">
                    <img 
                        src="/assets/tachiku_white_logo_180x60.png" alt="logo"
                    />
                    </div>
                    <div  className="grid_item--2 is--menu">
                        <p className="menu_p">Aplha release for OGs!</p>
                    </div>
                </div>
            </div>
        </div>
    );

}

